export const SET_LOADING = "SET_LOADING";
export const SET_ERRORS = "SET_ERRORS";
export const SET_FILTERS = "SET_FILTERS";

export const GET_CHANNEL_PARTNERS = "GET_CHANNEL_PARTNERS";
export const GET_CHANNEL_PARTNERS_SUCCESS = "GET_CHANNEL_PARTNERS_SUCCESS";
export const GET_CHANNEL_PARTNERS_FAILURE = "GET_CHANNEL_PARTNERS_FAILURE";

export const CREATE_CHANNEL_PARTNER = "CREATE_CHANNEL_PARTNER";
export const CREATE_CHANNEL_PARTNER_SUCCESS = "CREATE_CHANNEL_PARTNER_SUCCESS";
export const CREATE_CHANNEL_PARTNER_FAILURE = "CREATE_CHANNEL_PARTNER_FAILURE";

export const UPDATE_CHANNEL_PARTNER = "UPDATE_CHANNEL_PARTNER";
export const UPDATE_CHANNEL_PARTNER_SUCCESS = "UPDATE_CHANNEL_PARTNER_SUCCESS";
export const UPDATE_CHANNEL_PARTNER_FAILURE = "UPDATE_CHANNEL_PARTNER_FAILURE";

export const DELETE_CHANNEL_PARTNER = "DELETE_CHANNEL_PARTNER";
export const DELETE_CHANNEL_PARTNER_SUCCESS = "DELETE_CHANNEL_PARTNER_SUCCESS";
export const DELETE_CHANNEL_PARTNER_FAILURE = "DELETE_CHANNEL_PARTNER_FAILURE";

export const UPDATE_CHANNEL_PARTNER_STATUS = "UPDATE_CHANNEL_PARTNER_STATUS";
export const UPDATE_CHANNEL_PARTNER_STATUS_SUCCESS = "UPDATE_CHANNEL_PARTNER_STATUS_SUCCESS";
export const UPDATE_CHANNEL_PARTNER_STATUS_FAILURE = "UPDATE_CHANNEL_PARTNER_STATUS_FAILURE";
